module.exports = __webpack_public_path__ + "static/img/2108_phase_function_Paper_PointsHejduk_Prediction.6333863.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2108_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 0yn5
// module chunks = 0